module.exports = __webpack_public_path__ + "static/media/KER.5ac06d24.apng";